import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { EXTRA_INFO_MORE_BUSINESS_DETAILS_ROUTE } from '~/constants/routes';
import { useAppContent, useExtraInfo } from '~/hooks';
import { AppRoute } from '~/types/types';

const ReviewLandlordName = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.landlordDetails' });

  const { landlordName } = useExtraInfo();

  const list = landlordName
    ? [
        {
          label: '',
          data: landlordName,
        },
      ]
    : [
        {
          label: getTextContent('none'),
          data: '',
        },
      ];

  return (
    <ReviewList
      list={
        list.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={getTextContent('title')}
      editRoute={`${EXTRA_INFO_MORE_BUSINESS_DETAILS_ROUTE}#interested-third-parties` as AppRoute}
    />
  );
};

export default ReviewLandlordName;
